import { useEffect, useRef } from 'react'
import { motion } from '@/utils/motion'

/**
 * Staggers a container's direct children in the first time `ready` is true.
 * Under reduced motion nothing is hidden and nothing animates (motion.staggerIn
 * applies the visible end state directly).
 */
export function useStaggerIn<T extends HTMLElement>(ready: boolean) {
  const ref = useRef<T>(null)
  const played = useRef(false)

  useEffect(() => {
    if (!ready || played.current || !ref.current) return
    played.current = true
    void motion.staggerIn(Array.from(ref.current.children) as HTMLElement[])
  }, [ready])

  return ref
}
